import { useEffect } from 'react';
import { OccupancyReportWidget } from '../../../occupancy';
import { OccupancyReportWrapperProps } from './connect';

export const OccupancyReport = ({
    startPoller,
    resetWidget,
    selectedServiceId,
    start,
    end,
}: OccupancyReportWrapperProps) => {
    const props = {
        start,
        end,
        renderButtons: true,
        selectedServiceId,
    };

    useEffect(() => {
        startPoller({ start, end, serviceId: selectedServiceId });
        return resetWidget;
    }, [end, start, startPoller, selectedServiceId, resetWidget]);

    // @ts-expect-error $TSFixMeError: JSX element type 'OccupancyReportWidget' does not have any construct or call signatures.
    return <OccupancyReportWidget {...props} />;
};
